import { Platform } from 'react-native'
import { valueForKeyPath } from 'key.path'
// ///////////////////////////////////////////////////////
import { filterEmpty } from './utils'

// ///////////////////////////////////////////////////////
const defaultFonts = {
  primary: Platform.select({ ios: 'San Francisco', android: 'Roboto' }),
  body: Platform.select({ ios: 'San Francisco', android: 'Roboto' })
}
// ///////////////////////////////////////////////////////
const defaultFontSizes = {
  small: 13,
  medium: 17,
  large: 20,
  xlarge: 44
}
// ///////////////////////////////////////////////////////
const defaultLineHeights = {
  small: 16,
  medium: 18,
  large: 24,
  xlarge: 48
}
// ///////////////////////////////////////////////////////
const defaultFontWeights = {
  light: 300,
  regular: 400,
  normal: 400,
  bold: 700
}
// ///////////////////////////////////////////////////////
const defaultColors = {
  black: 'black',
  grey: '#CCC',
  white: 'white'
}
// ///////////////////////////////////////////////////////
export const composeTypegraphyStyles = props => {
  const fonts = valueForKeyPath('theme.fonts', props) || defaultFonts
  const fontFamily = props.font ? fonts[props.font] : null
  const fontSizes = valueForKeyPath('theme.fontSizes', props) || defaultFontSizes
  const fontSize = props.fontSize ? fontSizes[props.fontSize] : null
  const fontWeights = valueForKeyPath('theme.fontWeights', props) || defaultFontWeights
  const fontWeight = props.fontWeight ? fontWeights[props.fontWeight] : null
  const lineHeights = valueForKeyPath('theme.lineHeights', props) || defaultLineHeights
  const lineHeight = props.fontSize ? `${lineHeights[props.fontSize]}px` : null
  // const lineHeightRatio = props.lineHeight || valueForKeyPath('theme.lineHeight', props) || defaultLineHeight
  // const lineHeight = fontSize ? fontSize * lineHeightRatio : null
  const colors = valueForKeyPath('theme.colors', props) || defaultColors
  const color = props.clr ? colors[props.clr] : null
  return filterEmpty({ fontFamily, fontSize, fontWeight, lineHeight, color })
}
